import React from 'react';
import moment from 'moment';
import { ACTION_CREATE, ACTION_UPDATE } from '../CreateSiteModal/CreateSiteForm/components/CreateUpdateSite';
import OverflowMenu from '../OverflowMenu/OverflowMenu';
import { Button, ListGroup } from 'react-bootstrap';
import { PLANS } from '../../constants/plans';
import IconButton from '../IconButton';
import './LiveSitesTable.css';
import { copyToClipboard } from '../../utils/general';
import { useDispatch } from 'react-redux';
import { setDraggedFile, toggleModal } from 'Manage/actions';

const getDomain = (siteRecord) => siteRecord.subdomain;

const isProPlan = (productId) => productId === PLANS.PRO.id;

const AnalyticsCell = ({ enabled, onClick }) => (
  <td className="text-end">
    {enabled && (
      <button className="analytics-button tr-analytics-btn" onClick={onClick}>
        <span className="analytics-button-label me-2">View analytics</span>
        <img src="assets/icons/analytics.png" height="16px" alt="analytics" />
      </button>
    )}
  </td>
);

const StatusCell = ({ passwordProtected, domain }) => (
  <td className="ps-3 pe-2 text-center">
    <a href={`https://${domain}`} target="_blank">
      {passwordProtected ? (
        <img src="lock-link.svg" height="16px" alt="Password protected" title="Password protected" />
      ) : (
        <img src="assets/icons/circle-green.svg" height="14px" alt="live" />
      )}
    </a>
  </td>
);

const DomainCell = ({ label, href, trial }) => (
  <td className="text-start">
    <a href={href} target="_blank">
      <button className="domain-button text-start">
        <div className={`domain-button-label link me-2${trial ? ' trial' : ''}`}>{label}</div>
        <img className="open-icon" src="assets/icons/new-window.png" height="14px" alt="open" />
      </button>
    </a>
  </td>
);

const LiveSitesTable = ({ sites, onSiteAction, onEdit, userProfile, onArchive, onDelete, onDownload, onAnalytics,onQRCode }) => {
  const dispatch = useDispatch();

  const handleUpdateClick = (s) => {
    dispatch(setDraggedFile(null));
    dispatch(toggleModal(true));
    onSiteAction(ACTION_UPDATE, s);
  };

  return (
    <div className="box-100-scrolless">
      {sites.length > 0 ? (
        <div className="scroll-container">
          <table>
            <thead>
              <tr>
                <th className="table-header" style={{ width: '45px' }} />
                <th className="table-header" style={{ minWidth: '150px', width: '100%', maxWidth: '250px' }}>
                  DOMAIN
                </th>
                <th className="table-header" style={{ minWidth: '150px', width: '150px' }} />
                <th className="table-header" style={{ minWidth: '80px' }}>
                  UPDATED
                </th>
                <th className="table-header" style={{ minWidth: '100px', width: '100px' }}>
                  ACTIONS
                </th>
              </tr>
            </thead>
            <tbody className="sites-table">
              {sites.map((s, key) => (
                <tr key={key}>
                  <StatusCell passwordProtected={s.passwordProtected} domain={getDomain(s)} />
                  <DomainCell
                    label={`${getDomain(s)}`}
                    href={`https://${getDomain(s)}`}
                    trial={!!!userProfile.productId}
                  />
                  <AnalyticsCell
                    enabled={(userProfile.analyticsEnabled && s.analyticsEnabled) || s.analytics}
                    onClick={() => onAnalytics(s)}
                  />
                  <td>{s.lastUpdated || s.created ? moment(s.lastUpdated || s.created).format('DD MMM YY') : '-'}</td>
                  <td className="actions-col">
                    <IconButton
                      className="me-2"
                      src="/assets/icons/upload.png"
                      label="Update"
                      onClick={() => handleUpdateClick(s)}
                    />
                    <IconButton
                      className="me-2"
                      src="/assets/icons/copy.png"
                      onClick={() => copyToClipboard(`https://${getDomain(s)}`)}
                      tooltip="Copy link"
                    />
                       <IconButton
                      className="me-2"
                      src="/assets/icons/qr-code.svg"
                      onClick={() => onQRCode(s)}
                      tooltip="View QR Code"
                    />
                    <IconButton
                      className="me-2"
                      src="/assets/icons/thrash.png"
                      tooltip="Delete"
                      onClick={() => onDelete(s)}
                    />
                    <OverflowMenu>
                      {!isProPlan(userProfile.productId) && (
                        <ListGroup.Item onClick={() => onEdit(s)} action>
                          Edit code
                        </ListGroup.Item>
                      )}
                      {!s.disableArchive && (
                        <ListGroup.Item onClick={() => onArchive(s)} action>
                          Archive
                        </ListGroup.Item>
                      )}
                      <ListGroup.Item onClick={() => onDownload(s)} action>
                        Download
                      </ListGroup.Item>
                    </OverflowMenu>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="table-empty">
          <div>
            <span className="light-grey">No live sites</span>
          </div>
          <Button className="mt-3" size="sm" onClick={() => onSiteAction(ACTION_CREATE)}>
            Upload
          </Button>
        </div>
      )}
    </div>
  );
};

export default LiveSitesTable;
